import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { useGetTaxreturnPaymentByCurrentTaxpayer } from '../hooks/useGetTaxreturnByCurrentTaxpayer';

export const SuccessTaxReturnPayment = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const { loading, error, data } = useGetTaxreturnPaymentByCurrentTaxpayer(id as string);

  if (loading || error) {
    return <></>;
  }
  const createdDate = data?.createdDate as Date;
  const traduction = t('taxpayer-payments.messages.paymentRegisteredSucessfully');

  const backToHomeText = t('common.label.backToHome');
  const message = traduction.replace('[createDate]', createdDate.toLocaleDateString());
  return (
    <>
      <div>
        <div className="mt-5 d-flex justify-content-center">
          <Icon.Check2Circle size={130} color="green" />
        </div>
        <div className="mt-2 d-flex justify-content-center">
          <h3 className="">{data?.paymentNumber ?? 'XXX-NUMBER'}</h3>
        </div>
        <div className="d-flex justify-content-center">
          <div>{message}.</div>
        </div>

        <div className="d-flex justify-content-center mt-2">
          <Link to="/">{backToHomeText}</Link>
        </div>
      </div>
    </>
  );
};
